// Wording of the quick-match card's opening choice (hero version C). Tags
// filled in per community: {people} (quickMatchPeopleWord, e.g.
// "golfers"), {matchLabel} (e.g. "golf partner"), {started} (the month the
// community was made, e.g. "July 2026").
const INTRO_TEXT = {
  quickMatchIntroLead: 'We are a new Interconnector, started in {started}, that finds and introduces you to other {people} looking for a {matchLabel}.',
  quickMatchIntroText: 'New members are joining daily. If no one is a good fit, we can let you know when someone joins!',
  quickMatchIntroJoin: 'Join and get introduced',
  quickMatchIntroLook: "See who's near me first",
  quickMatchIntroNote: "Just a quick look — to connect with anyone, you'll need to join.",
};

// When the community was made ("July 2026"), from its id's timestamp.
export const communityStartedIn = (communityId) => {
  const id = String(communityId || '');
  if (!/^[0-9a-f]{24}$/i.test(id)) return '';
  return new Date(parseInt(id.slice(0, 8), 16) * 1000).toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });
};

// A piece of the wording with its tags filled in.
export const introText = (key, { people = 'people', matchLabel = '', started = '' } = {}) =>
  String(INTRO_TEXT[key] || '')
    .replace(/\{people\}/g, people)
    .replace(/\{matchLabel\}/g, matchLabel && matchLabel !== 'friend' ? matchLabel : 'friend')
    .replace(/\{started\}/g, started);
